<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Aneks do umowy zlecenie z dnia {{datazdnia}}</strong>
</p>
<p>
    Zawarty w dniu {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}} w Łodzi pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi 
  przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną 
  do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego
  przez Sąd Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego 
  pod nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>, zwaną w dalszej części Umowy <strong>Zleceniodawcą</strong>
</p>
<p>
  a​ Zleceniobiorcą:
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  adres zamieszkania: {{zamieszkany}}
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong>
</p>
<p>
  Strony zgodnie postanawiają, że od dnia zawarcia aneksu do :
<ul style="list-style-type: inherit;">
<li>
<strong>§ 6 ust. 1 umowy</strong> zostaje poszerzony o następującą treść: <br>
“W przypadku przeprowadzenia lekcji pokazowej wynagrodzenie za każdą godzinę lekcji pokazowej wynosi 30,00 zł brutto (słownie: trzydzieści złotych).
</li>
<li>
<strong> § 6 dodany ust. 5 </strong> o następującej treści: <br>
Zleceniodawca może przyznać premię uznaniowej w wysokości do 10% wynagrodzenia brutto pod warunkiem bardzo wysokiej jakości prowadzonych lekcji i ich organizacji oraz zaangażowania w wykonywane zlecenia mierzonego elementami: 100% frekwencji, wypełnianie założeń merytorycznych i organizacyjnych określonych w niniejszej umowie oraz zgodnie z wytycznymi określonymi przez koordynatora. Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia okresu rozliczeniowego po miesiącu bądź kwartalnie w zależności od ustaleń pomiędzy stronami umowy.

</li>
<li>
  <strong>§ 6 zostaje dodany ust. 6 o następującej treści:</strong>
Zleceniodawca może obniżyć do 10% wynagrodzenie brutto za dany miesiąc, w przypadku niestosowania się do zapisów: § 1 ust. 1, §3 ust. 1-3 zawartej umowy czy § 4 ust.1-4,, w szczególności: 
<ul>
<li>nie dotrzymywania podanej dyspozycyjności,
</li>
<li>nie odpisywania na e-maile oraz nie odbierania telefonów od osób wskazanych do kontaktu przez Zleceniodawcę,</li>
<li>uzasadnionych skarg rodziców na jakość prowadzonych lekcji,</li>
<li>nie wywiązywania się z obowiązku oceniania dzieci w ramach co 2-miesięcznych raportów,</li>
<li>nie zachowywania zasad kultury osobistej na zajęciach oraz w kontakcie z osobami wskazanymi przez Zleceniodawcę,</li>
<li>niewywiązywania się z wytycznych dotyczących programu i jakości prowadzonych zajęć edukacyjnych określonych przez Zleceniodawcę,</li>
</ul>
</li>
</ul>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong>
</p>
<p>Pozostałe warunki umowy pozostają bez zmian.</p>
<div class="cointainer" style="margin-top: 20px; margin-bottom: 10px;">
  <div class="left-cointainer">
    {{zamawiajacy}}<br>
    <span class="caption">(Zleceniodawca)</span>
  </div>
  <div class="right-cointainer">
    {{imieNazwisko}}<br>
    <span class="caption">(Zleceniobiorca)</span>
  </div>
</div>
</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaGitaraAneks',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      pesel: '',
      datazdnia: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 290mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaGitaraAneks2.vue